/**
 * Network Monitor Service - Optimized
 * 
 * Servicio LIGERO para monitorear el estado de conexión a Internet.
 * Optimizado para aplicaciones de punto de venta con recursos limitados.
 * 
 * Características:
 * - Solo usa eventos nativos del navegador (sin polling)
 * - Cero impacto en rendimiento cuando hay conexión estable
 * - Mínimo uso de memoria
 * - No hace peticiones periódicas
 * 
 * @author BissTrack Team
 * @version 2.0.0 (Optimized)
 */

class NetworkMonitor {
  constructor() {
    this.isOnline = navigator.onLine;
    this.toast = null;
    this.hasShownOfflineNotification = false;
  }

  /**
   * Inicializa el monitor de red (solo eventos nativos)
   * @param {Object} toastInstance - Instancia de Vue Toast
   */
  initialize(toastInstance) {
    this.toast = toastInstance;
    this._setupEventListeners();
    console.log('[NetworkMonitor] Inicializado (modo optimizado)');
  }

  /**
   * Configura SOLO los event listeners nativos del navegador
   * @private
   */
  _setupEventListeners() {
    // Evento cuando se pierde la conexión
    window.addEventListener('offline', () => {
      this.isOnline = false;
      this._notifyOffline();
    });

    // Evento cuando se recupera la conexión
    window.addEventListener('online', () => {
      this.isOnline = true;
      this._notifyOnline();
    });
  }

  /**
   * Notifica al usuario que está sin conexión
   * @private
   */
  _notifyOffline() {
    // Evitar múltiples notificaciones
    if (this.hasShownOfflineNotification) return;
    
    if (this.toast) {
      this.toast.error('⚠️ SIN CONEXIÓN A INTERNET', {
        duration: 0,
        position: 'top',
        dismissible: true,
        queue: false,
        className: 'network-toast network-toast-offline',
      });
      this.hasShownOfflineNotification = true;
    }
    console.warn('[NetworkMonitor] Sin conexión');
  }

  /**
   * Notifica al usuario que se recuperó la conexión
   * @private
   */
  _notifyOnline() {
    if (this.toast) {
      this.toast.clear();
      this.toast.success('✅ CONEXIÓN RESTABLECIDA', {
        duration: 4000,
        position: 'top',
        queue: false,
        className: 'network-toast network-toast-online',
      });
      this.hasShownOfflineNotification = false;
    }
    console.info('[NetworkMonitor] Conexión restablecida');
  }

  /**
   * Obtiene el estado actual de la conexión
   * @returns {boolean} true si hay conexión, false si no
   */
  getConnectionStatus() {
    return navigator.onLine;
  }

  /**
   * Limpia recursos (mínimo, solo para compatibilidad)
   */
  destroy() {
    console.log('[NetworkMonitor] Limpiado');
  }
}

// Exportar instancia única (Singleton)
export default new NetworkMonitor();
